import { gql } from "@apollo/client";

export const PRICE_LIST_QUERY = gql`
  query PriceListQuery {
    priceDocuments {
      id
      title
      displayName
      url
      contentType
      description
      filename
    }
  }
`;
